<template>
    <div class="manage--left" ref="lesson-left">
        <!-- Search -->
        <div class="manage--search--left student">
            <input type="text" autocomplete="off" v-model="keyword" :placeholder="$t('search.keyWord')" class="input--search--left" />
        </div>
        <!-- Nội dung -->
        <div class="div-list-lessons" :class="{ht: !mobile}">
            <div class="search--type">
                <button class="search--type--btn" :class="{'active--nqt': filterByName}" @click="filterByName = true">{{$t("profile.name")}}</button>
                <button class="search--type--btn" :class="{'active--nqt': !filterByName}" @click="filterByName = false">{{$t("profile.email")}}</button>
            </div>
            <!-- Danh sách -->
            <template v-for="(item, index) in students">
                <div class="nqt--list--lessons" :class="[{active: item.id == itemActive.id}]" v-on:click="toogleStudent(item)" :key="index">
                    <p class="title-lesson" v-if="filterByName">
                        <template v-if="item.userName.search('@') !== -1">{{item.userName.substring(0, item.userName.search('@'))}}</template>
                        <template v-if="item.userName.search('@') == -1">{{item.userName}}</template>
                    </p>
                    <p class="title-lesson" v-if="!filterByName">
                        {{item.email}}
                    </p>
                    <span class="lopMN">{{item.deptNames}}</span>
                </div>
            </template>
        </div>
        <!-- Loading -->
        <loading class="loading--lesson" :showLoading="loadingStudent"/>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import loading from "@/components/loading/loading";

    export default {
        data() {
            return {
                keyword: null,
                data: [],
                filterByName: true,
                itemActive: null,
                loadingStudent: true
            };
        },
        components: {
            loading,
        },
        computed: {

            // Tìm kiếm học viên
            students: function () {
                let keyword = this.keyword;
                let result = [];
                
                if (keyword == null || keyword == "") {
                    result = this.data;
                } else {
                    keyword = keyword.toUpperCase();
                    let field = this.filterByName ? 'userName' : 'email';
                    result = this.data.filter((item) => item[field].toUpperCase().indexOf(keyword) > -1);
                }
                return result;
            },

            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        watch: {
            // Thay đổi học viên
            itemActive (value) {
                this.$emit("toogleStudent", value);
            }
        },
        created() {
            this.init();
        },
        methods: {

            init: async function () {
                this.data = await this.getAllStudent();
                this.loadingStudent = false;
                this.itemActive = this.data[0];
            },

            // Thay dổi học viên
            toogleStudent: function (item) {
                this.itemActive = item;
                document.getElementsByTagName("body")[0].classList.remove("show-menu-1");
            },

            // Lấy danh sách học viên mà giao viên phụ trách
            getAllStudent: function () {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/collegecourse/getAllStudent", {})
                        .then((response) => {
                            let data = response.data;
                            data.sort(function (a, b) {
                                if (a.deptNames == b.deptNames) {
                                    if (a.userName != null && b.userName != null) {
                                        return a.userName.localeCompare(b.userName);
                                    }
                                } else {
                                    if (a.deptNames != null && b.deptNames != null) {
                                        return a.deptNames.localeCompare(b.deptNames);
                                    }
                                }
                            })
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
        },
    };
</script>
<style scoped>
    .lopMN {
        padding: 0 10px;
        font-size: 11px;
        -webkit-line-clamp: 1!important;
        margin-top: 2px;
        /* color: #7f8c8d; */
        font-style: italic;
    }
    .title-lesson {
        font-weight: bold;
    }
    .button--search--left {
        border: 1px solid #0071c5;
        width: auto !important;
    }
    .nqt--list--lessons {
        cursor: pointer !important;
    }
    .div-list-lessons {
        cursor: pointer !important;
        overflow: auto;
        height: 675px;
        overflow-x: hidden;
    }
    .nqt-end {
        background: #1f1313;
        height: calc(100% - 10px);
        position: absolute;
        right: 5px;
        width: auto;
        top: 5px;
        color: #fff;
        padding: 7px;
        font-size: 10px;
        border-radius: 7px;
        display: flex;
    }
    .nqt--list--lessons:hover {
        background: #d7d7d7;
    }
    .isTeacher {
        color: #9b99a2;
    }
    .btn_download {
        background: transparent;
        border: none;
        border-radius: 5px;
        margin-left: 2px;
    }
    .btn_download:hover {
        background: #d7d7d7;
    }
    /* custom */
    .div-list-lessons {
        border: 1px solid #e3e3e3;
        padding: 5px;
        border-radius: 5px;
        margin-top: 5px;
        padding-bottom: 0;
    }
    .ht {
        height: calc(100% - 40px) !important;
    }
    .nqt--list--lessons {
        border-bottom: 1px solid #e3e3e3;
    }
    .nqt--list--lessons.active,
    .nqt--list--lessons:hover {
        background: #0071c5;
        color: #fff;
        border-radius: 5px;
    }
    .manage--left {
        box-shadow: none;
        padding-top: 0;
        padding-bottom: 0;
        border: none;
    }
    .search--type {
        display: flex;
        justify-content: center;
        height: 36px;
        margin-bottom: 5px;
    }
    .search--type--btn {
        border: 0;
        color: #e3e3e3;
        font-size: 12px;
        width: 50%;
        background: transparent;
        font-weight: 300;
    }
    .search--type--btn.active--nqt {
        color: #0071c5;
        border-bottom: 2px solid #0071c5;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/left/students.vue